import { LayoutDashboard } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function TermsOfUsePage() {
  const effectiveDate = 'January 1, 2026';

  return (
    <div className="min-h-screen" style={{ background: '#F7F6F2' }}>
      <header className="flex items-center justify-between px-8 py-5" style={{ borderBottom: '1px solid #E5E3DB', background: '#FFFFFF' }}>
        <Link to="/" className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: '#D98A4A' }}>
            <LayoutDashboard size={16} className="text-white" />
          </div>
          <span className="font-heading text-lg font-semibold italic" style={{ color: '#1A1A1A' }}>AI Snugglemind</span>
        </Link>
        <div className="flex items-center gap-4 font-body text-sm">
          <Link to="/privacy" className="hover:underline" style={{ color: '#4B5563' }}>Privacy Policy</Link>
          <Link to="/subscription-agreement" className="hover:underline" style={{ color: '#4B5563' }}>Subscription Agreement</Link>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-6 py-12" data-testid="terms-of-use-page">
        <h1 className="font-heading text-4xl font-medium mb-2" style={{ color: '#1A1A1A' }}>Terms of Use</h1>
        <p className="font-body text-sm mb-10" style={{ color: '#9CA3AF' }}>Effective Date: {effectiveDate}</p>

        <div className="space-y-8 font-body text-sm leading-relaxed" style={{ color: '#4B5563' }}>
          <section>
            <h2 className="font-heading text-xl font-medium mb-3" style={{ color: '#1A1A1A' }}>1. Acceptance of Terms</h2>
            <p>By accessing or using the AI Snugglemind platform ("Service"), operated by Snugglemind Inc. ("Company," "we," "us," or "our"), you agree to be bound by these Terms of Use ("Terms"). If you do not agree to these Terms, you may not access or use the Service.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium mb-3" style={{ color: '#1A1A1A' }}>2. Description of Service</h2>
            <p>AI Snugglemind is an AI-powered bookkeeping and transaction analysis platform that provides hybrid AI classification, financial reporting, reconciliation workflows, and related accounting tools. The Service is designed to assist with bookkeeping tasks but does not constitute professional accounting, tax, or legal advice.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium mb-3" style={{ color: '#1A1A1A' }}>3. Account Registration</h2>
            <p>To use the Service, you must create an account by providing accurate and complete information. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account at admin@snugglemind.com.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium mb-3" style={{ color: '#1A1A1A' }}>4. Permitted Use</h2>
            <p>You may use the Service solely for lawful business purposes in accordance with these Terms. You agree not to:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Use the Service for any unlawful purpose or in violation of any applicable laws or regulations</li>
              <li>Attempt to gain unauthorized access to any portion of the Service or its related systems</li>
              <li>Interfere with or disrupt the integrity or performance of the Service</li>
              <li>Reverse engineer, decompile, or disassemble any aspect of the Service</li>
              <li>Use the Service to transmit any viruses, malware, or other harmful code</li>
              <li>Resell, sublicense, or redistribute the Service without prior written consent</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium mb-3" style={{ color: '#1A1A1A' }}>5. Intellectual Property</h2>
            <p>All content, features, and functionality of the Service, including but not limited to text, graphics, logos, icons, software, and AI models, are the exclusive property of Snugglemind Inc. and are protected by copyright, trademark, and other intellectual property laws. You retain ownership of all data you upload to the Service.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium mb-3" style={{ color: '#1A1A1A' }}>6. AI-Generated Content Disclaimer</h2>
            <p>The Service uses artificial intelligence to analyze transactions and suggest classifications. AI-generated suggestions are provided for informational purposes and should not be considered a substitute for professional accounting judgment. You are solely responsible for reviewing and approving all AI-generated classifications before they are finalized in your records.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium mb-3" style={{ color: '#1A1A1A' }}>7. Limitation of Liability</h2>
            <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, SNUGGLEMIND INC. SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, DATA, OR BUSINESS OPPORTUNITIES, ARISING OUT OF OR RELATED TO YOUR USE OF THE SERVICE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT PAID BY YOU FOR THE SERVICE IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium mb-3" style={{ color: '#1A1A1A' }}>8. Indemnification</h2>
            <p>You agree to indemnify, defend, and hold harmless Snugglemind Inc., its officers, directors, employees, and agents from and against any claims, damages, losses, liabilities, costs, and expenses arising out of or related to your use of the Service or violation of these Terms.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium mb-3" style={{ color: '#1A1A1A' }}>9. Termination</h2>
            <p>We may suspend or terminate your access to the Service at any time, with or without cause, with or without notice. Upon termination, your right to use the Service will immediately cease. Provisions that by their nature should survive termination shall remain in effect.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium mb-3" style={{ color: '#1A1A1A' }}>10. Modifications to Terms</h2>
            <p>We reserve the right to modify these Terms at any time. We will notify you of material changes by posting the updated Terms on the Service with a new effective date. Your continued use of the Service after such changes constitutes acceptance of the modified Terms.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium mb-3" style={{ color: '#1A1A1A' }}>11. Governing Law</h2>
            <p>These Terms shall be governed by and construed in accordance with the laws of the State of Delaware, United States, without regard to its conflict of law provisions. Any disputes arising under these Terms shall be resolved in the state or federal courts located in Delaware.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-medium mb-3" style={{ color: '#1A1A1A' }}>12. Contact Us</h2>
            <p>If you have any questions about these Terms, please contact us at:</p>
            <p className="mt-2"><strong style={{ color: '#1A1A1A' }}>Snugglemind Inc.</strong><br />Email: admin@snugglemind.com</p>
          </section>
        </div>

        <div className="mt-12 pt-6 flex items-center gap-4 font-body text-xs" style={{ borderTop: '1px solid #E5E3DB', color: '#9CA3AF' }}>
          <span>&copy; {new Date().getFullYear()} Snugglemind Inc. All rights reserved.</span>
          <Link to="/privacy" className="hover:underline" style={{ color: '#D98A4A' }}>Privacy Policy</Link>
          <Link to="/subscription-agreement" className="hover:underline" style={{ color: '#D98A4A' }}>Subscription Agreement</Link>
        </div>
      </div>
    </div>
  );
}
